import { Row, Col, Form, Modal } from "antd";
import { MdDelete } from "react-icons/md";
import React, { Fragment } from "react";
import { AddButton, DeleteButton } from "../../styled/Button.styled";
import { ICategoryByIdResponse } from "../../../types/category";
import SelectVehicleMake from "../../selectOption/SelectVehicleMake";
import SelectVehicleModel from "../../selectOption/SelectVehicleModel";
import { useDeleteVehicleByIdMutation } from "../../../feature/Category/categoryApiSlice";

type CategoryProps = {
  data?: ICategoryByIdResponse;
};

function CategoryForm(props: CategoryProps) {
  const { data } = props;
  const [form] = Form.useForm();
  const { confirm } = Modal;
  const [deleteVehicle] = useDeleteVehicleByIdMutation();

  const showConfirm = (id: number) => {
    confirm({
      title: "Do You Want To Delete Category?",
      onOk() {
        onDelete(id);
      },
      onCancel() {},
    });
  };

  const onDelete = (id: number) => {
    deleteVehicle({
      categoryId: data?.data?.id,
      id: data?.data?.vehicles[id].id,
    });
  };

  return (
    <>
      <Form
        layout="vertical"
        form={form}
        name="categoryVehiclesForm"
        initialValues={{
          vehicles: data?.data?.vehicles || [],
        }}
      >
        <Row gutter={[32, 22]}>
          <Col span={24}>
            <Form.List name="vehicles">
              {(fields, { add, remove }) => (
                <>
                  <Row
                    gutter={[16, 16]}
                    justify="space-between"
                    align="middle"
                    className="category-header-row"
                  >
                    <Col>
                      <Row gutter={[8, 8]} align="middle">
                        {data?.data?.name && (
                          <>
                            <Col>
                              <label>Category Name:</label>
                            </Col>
                            <Col>
                              <span>{data.data.name}</span>
                            </Col>
                          </>
                        )}
                      </Row>
                    </Col>
                    <Col>
                      <AddButton onClick={() => add()}>Add Vehicle</AddButton>
                    </Col>
                  </Row>

                  <Row
  className="borderCategoryChart"
  gutter={[0, 16]}
  style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}
>
  {fields.map((field, index) => {
    const isLastOdd =
      fields.length % 2 === 1 && index === fields.length - 1;

    return (
      <Col
        key={field.key}
        style={{
          flex: "0 1 calc(50% - 8px)", // 2 per row with gutter
          margin: isLastOdd ? "0 auto" : undefined, // center last if odd
        }}
      >
        <div className="borderRecord">
          <Row
            gutter={[16, 16]}
            align="middle"
            justify="space-between"
            className="vehicle-item-row"
          >
            <Col style={{ minWidth: "24px" }}>
              <strong>{index + 1}.</strong>
            </Col>
            <Col className="common-select-dropdown">
              <SelectVehicleMake
                name={[index, `id`]}
                rules={[
                  {
                    required: true,
                    message: "Please select vehicle make",
                  },
                ]}
                label="Vehicle Make"
                form={form}
              />
            </Col>
            <Col className="common-select-dropdown">
              <SelectVehicleModel
                name={[index, `vehicleModel`]}
                rules={[
                  {
                    required: true,
                    message: "Please select vehicle model",
                  },
                  ({ getFieldsValue }) => ({
                    validator: async (_, value) => {
                      const count =
                        getFieldsValue().vehicles.filter(
                          (val: any) =>
                            val.vehicleModel === value
                        );
                      if (count.length > 1) {
                        return Promise.reject(
                          "cannot have same vehicle model"
                        );
                      } else {
                        return Promise.resolve();
                      }
                    },
                  }),
                ]}
                label="Vehicle Model"
                form={form}
              />
            </Col>
            <Col>
              {fields.length > 1 ? (
                <DeleteButton
                  onClick={() => {
                    remove(field.name);
                  }}
                />
              ) : null}
            </Col>
          </Row>
        </div>
      </Col>
    );
  })}
</Row>


                </>
              )}
            </Form.List>
          </Col>
        </Row>
      </Form>
    </>
  );
}

export default CategoryForm;
